import axios from "../../../../utils/axios-private";
import { requestDefaultGenerator } from "../../../../utils/generator";

export const getListUsers = ({ pageNumber, pageSize, filter }) => {
  if (filter.paramsName !== null && filter.paramsName !== undefined) {
    filter.nama_lengkap = `%${filter.paramsName}%`;
    delete filter.paramsName;
  }
  const initialRequest = { limit: pageSize, page: pageNumber };
  const request = requestDefaultGenerator(initialRequest, filter);
  return {
    type: "GET_LIST_USER",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/user/list`;
      axios
        .post(url, request, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
